export default __webpack_public_path__ + "static/media/Andorra2016.c6aa7c29.jpg";